function isValidNumber(value: string) {
  return /^\d+$/.test(value);
}

export default isValidNumber;
